import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import Modal from 'react-responsive-modal'

const ModalWrapper = ({ children, openModal, size, hideCloseIcon, closeOnOverlayClick, onClose }) => {
  const classModal = classNames('modal-content', 'modal-content-react', {
    'modal-sm': size === 'S',
    'modal-dialog': size === 'M',
    'modal-lg': size === 'L',
    'modal-xl': size === 'XL',
    'modal-xxl': size === 'XXL'
  })

  return (
    <Modal
      open={openModal}
      center
      classNames={{
        overlay: 'modal-backdrop',
        modal: classModal,
        closeButton: 'modal-close',
        transitionEnter: 'fade-in-down-little', // TODO
        transitionExit: ''
      }}
      onClose={onClose}
      showCloseIcon={!hideCloseIcon}
      closeOnOverlayClick={closeOnOverlayClick}
    >
      {children}
    </Modal>
  )
}

ModalWrapper.defaultProps = {
  size: 'M',
  type: 'confirm',
  hideCloseIcon: false,
  closeOnOverlayClick: true
}

ModalWrapper.propTypes = {
  children: PropTypes.node,
  openModal: PropTypes.bool,
  size: PropTypes.oneOf(['S', 'M', 'L', 'XL', 'XXL']),
  callback: PropTypes.func,
  hideCloseIcon: PropTypes.bool,
  closeOnOverlayClick: PropTypes.bool
}

export default ModalWrapper
